import { render } from "./ClinicianIcon.vue?vue&type=template&id=6ca77390"
import script from "./ClinicianIcon.vue?vue&type=script&lang=js"
export * from "./ClinicianIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__